/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import {
    makeAsyncReducer,
    asyncDefaults,
    mergeReducers,
} from 'ui-lottery/src/utils/async_utils';
import * as types from '../constants/actions';
import { PassSeriesDefaults } from '../props/passSeries';

const fetchPassSeries = makeAsyncReducer(types.FETCH_PASS_SERIES);

const passSeries = mergeReducers(
    asyncDefaults(PassSeriesDefaults),
    types.PREFIX,
    fetchPassSeries
);

export default passSeries;

// Selectors
export const selectors = {
    getSeries: (state) => state.pass.passSeries.data,
};
